import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

import { CorePlatformService } from '@core/infrastructure/platform/platform.service';

@Injectable()

/**
 * Page title service
 */
export class PageTitleService {
    private readonly renderer: Renderer2;

    constructor(
        private readonly rendererFactory: RendererFactory2,
        @Inject(DOCUMENT) private readonly document: Document,
        private readonly platformService: CorePlatformService,
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    public setTitle(title: string): void {
        if (title?.length > 0) {
            this.addTitleBeforePreconnect(title);
        }
    }

    public setCustomTitle(title: string): void {
        const fullTitle = `${title?.length > 0 ? `${title} - ` : ''}Massimo Dutti`;
        this.addTitleBeforePreconnect(fullTitle);
    }

    public addTitleBeforePreconnect(title: string): void {
        if (this.platformService.isBrowser()) {
            const head = this.document.head;
            const preconnectLink = head.querySelector('link[rel="preconnect"]');

            const existingTitleElement = head.querySelector('title');
            if (existingTitleElement) {
                this.renderer.removeChild(head, existingTitleElement);
            }

            const titleElement = this.renderer.createElement('title');
            const text = this.renderer.createText(title);

            this.renderer.appendChild(titleElement, text);

            if (preconnectLink) {
                this.renderer.insertBefore(head, titleElement, preconnectLink);
            } else {
                this.renderer.appendChild(head, titleElement);
            }
        }
    }
}
